// =========================================================
// Vojjin Moddal Utilities
// =========================================================
import {registerGlobal} from "./core.js";

class Moddal {
    constructor({title = "", content = "", size = "medium", type = "info", buttons = []}) {
        this.title = title;
        this.content = content;
        this.size = size;
        this.type = type;
        this.buttons = buttons;
        this.overlay = null;
        this.moddal = null;
        this.keyHandler = this.handleKey.bind(this);
    }

    create() {
        // Ensure moddal root exists
        let root = document.getElementById("moddal-root");
        if (!root) {
            root = document.createElement("div");
            root.id = "moddal-root";
            document.body.appendChild(root);
        }

        // Emoji by type
        const emojiMap = {
            info: "ℹ️",
            success: "✅",
            warning: "⚠️",
            danger: "❌",
            question: "❓",
            none: ".",
            default: "💬"
        };
        const emoji = emojiMap[this.type] || emojiMap.default;

        // Overlay
        this.overlay = document.createElement("div");
        this.overlay.className = "moddal-overlay";

        // moddal container
        this.moddal = document.createElement("div");
        this.moddal.className = `moddal moddal--${this.size} moddal--${this.type}`;

        // Header
        const header = document.createElement("div");
        header.className = "moddal-header";
        header.innerHTML = `
      <span class="moddal-title">${this.title}</span>
      <button class="close-btn" aria-label="Close">&times;</button>
    `;

        // Body with emoji icon
        const body = document.createElement("div");
        body.className = "moddal-body";
        body.innerHTML = `
      ${emoji === '.' ? '' : `<div class="moddal-icon">${emoji}</div>`}
      <div class="moddal-text">${this.content}</div>
    `;

        // Footer
        const footer = document.createElement("div");
        footer.className = "moddal-footer";

        this.buttons.forEach(btn => {
            const button = document.createElement("button");
            button.textContent = btn.text;
            button.className = btn.class || "btn";
            if (btn.onClick) button.addEventListener("click", btn.onClick);
            footer.appendChild(button);
        });

        // Assemble moddal
        this.moddal.append(header, body, footer);
        this.overlay.appendChild(this.moddal);
        root.appendChild(this.overlay);

        // Event listeners
        header.querySelector(".close-btn").addEventListener("click", () => this.close());
        this.overlay.addEventListener("click", e => {
            if (e.target === this.overlay) this.close();
        });
        document.addEventListener("keydown", this.keyHandler);
    }

    open() {
        if (!this.overlay) this.create();
        setTimeout(() => this.overlay.classList.add("active"), 10);
    }

    close() {
        if (!this.overlay) return;
        this.overlay.classList.remove("active");
        document.removeEventListener("keydown", this.keyHandler);
        setTimeout(() => this.overlay.remove(), 200);
    }

    handleKey(e) {
        if (e.key === "Escape") this.close();
    }

    static confirm(title, content, callback) {
        const moddal = new Moddal({
            title: title,
            content: content,
            size: "sm",
            type: "question",
            buttons: [
                {text: "Ne", onClick: () => moddal.close()},
                {text: "Da", class: "btn btn-primary", onClick: () => { callback(); moddal.close() }}
            ]
        });
        moddal.open();
    }

    static alert(title, content, type, callback) {
        const moddal = new Moddal({
            title: title,
            content: content,
            size: "sm",
            type: type,
            buttons: [
                {
                    text: "OK", onClick: () => {
                        if (callback) callback();
                        moddal.close()
                    }
                },
            ]
        });
        moddal.open();
    }

    static alertInfo(title, content, callback) {
        Moddal.alert(title, content, "info", callback);
    }

    static alertDanger(title, content, callback) {
        Moddal.alert(title, content, "danger", callback);
    }

    static alertSuccess(title, content, callback) {
        Moddal.alert(title, content, "sucess", callback);
    }

    static input(title, text, help, value, callback) {
        let htmlContent = `
        <div style="display:flex;" class="w-100">
            <div class="form-floating w-100">
                <input type="text" class="form-control" id="module_input" name="module_input" placeholder=" "
                       value="${value}"/>
                <label for="module_input" id="module_label" style="color:var(--bs-gray-400);">${text}</label>
                <small id="module_inputHelp" class="form-text text-muted">${help}</small>
            </div>
        </div>`;
        const moddal = new Moddal({
            title: title,
            content: htmlContent,
            size: "sm",
            type: "none",
            buttons: [
                {text: "Prekini", onClick: () => moddal.close()},
                {text: "Snimi", class: "btn btn-primary", onClick: () => callback(moddal)}
            ]
        });
        moddal.open();
    }
}

registerGlobal("Moddal", Moddal);
